<template>
  <div class="" style="padding: 0; height: 25vh; width: 100%">
    <div
      class=""
      id="waterOnDemandThree"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
      style="height: 100%; width: 100%"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  props: {
    waterData: {
      type: String,
    },
  },
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    this.init();
  },
  methods: {
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      if (this.myChart) {
        clearInterval(this.dispatchTimer);
        this.myChart.clear();
      }
      let that = this;
      that.myChart = echarts.init(
        document.getElementById("waterOnDemandThree")
      );

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      const stateData = {
        xAxisData: JSON.parse(this.waterData.xaxis),
        sgData: JSON.parse(this.waterData.firstSoil),
        bgData: JSON.parse(this.waterData.afterSoil),
      };
      var option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "4%",
          right: "2%",
          top: "15%",
          bottom: "8%",
        },
        legend: {
          itemWidth: 7,
          itemHeight: 7,
          // itemGap: 15,
          icon: "rect",
          // right: 0,
          textStyle: {
            fontSize: 14,
            fontFamily: "PingFangSC, PingFang SC",
            fontWeight: 400,
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: stateData.xAxisData,
          axisLabel: {
            fontSize: 14,
            fontFamily: "PingFangSC, PingFang SC",
            fontWeight: 400,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "#2B7BD6",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#153D7D",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "单位/件",
          nameTextStyle: {
            fontSize: 14,
            fontFamily: "PingFangSC, PingFang SC",
            fontWeight: 400,
          },
          axisLabel: {
            fontSize: 14,
            fontFamily: "PingFangSC, PingFang SC",
            fontWeight: 400,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "#2B7BD6",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#153D7D",
            },
          },
        },
        series: [
          {
            name: "灌溉前土壤湿度",
            data: stateData.sgData,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "rgba(255, 116, 133, 1)",
                lineStyle: {
                  color: "rgba(255, 116, 133, 1)",
                  width: 2,
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(255, 116, 133, 0)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 116, 133, 1)",
                    },
                  ]),
                },
              },
            },
          },
          {
            name: "灌溉后土壤湿度",
            data: stateData.bgData,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "rgba(95, 175, 255, 1)",
                lineStyle: {
                  color: "rgba(95, 175, 255, 1)",
                  width: 2,
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(95, 175, 255, 0)",
                    },
                    {
                      offset: 1,
                      color: "rgba(95, 175, 255, 1)",
                    },
                  ]),
                },
              },
            },
          },
        ],
      };

      that.dataLen = option.series[0].data.length;
      that.dispatchActions();

      that.myChart.setOption(option);
      //   this.interVal = setInterval(function () {
      //     that.myChart.clear();
      //     that.myChart.setOption(option);
      //   }, 240000);
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>